<template>
    <div class="rich-container">
        <div
            ref="rich"
            class="rich-container--style"
            v-html="filterXSS(remark)"
        >
        </div>
        <div class="rich-container--btn">
            <sp-button
                type="primary"
                size="large"
                @click="handleClick"
            >
                立即修改信息
            </sp-button>
        </div>
    </div>
</template>
<script>
import { Button } from '@ks/sharp-ui';
import { filterXSS } from '../../../utils';
export default {
    name: 'rich-text',
    components: {
        SpButton: Button,
    },
    props: {
        remark: {
            type: String,
            default: () => '',
        },
    },
    methods: {
        filterXSS(html) {
            return filterXSS(html);
        },
        handleClick() {
            this.$emit('emit-click');
        },
    },
};
</script>
<style lang="less" scoped>
.rich-container {
    &--style {
        line-height: 0.27rem;
        text-align: left;
        word-break: break-all;
        padding-bottom: 0.2rem;
        padding: 0 19px;

        /deep/ img {
            max-width: 100%;
            width: unset;
        }

        /deep/ a {
            color: #385080;
            -webkit-touch-callout: none;
        }

        /deep/ h1,
        /deep/h2 {
            margin: 0 !important;
        }
        /deep/ h3,
        /deep/ h4,
        /deep/h5,
        /deep/h6 {
            margin: 0;
            font-size: 0.15rem;
            font-weight: 400;
            line-height: normal;
        }
        /deep/ h1 {
            font-size: 0.18rem !important;
            line-height: 0.25rem;
            padding-bottom: 0.16rem;
        }
        /deep/ h2 {
            font-size: 0.15rem !important;
            line-height: 0.21rem;
            padding-bottom: 0.08rem;
        }
        /deep/ p {
            margin: 0;
            line-height: 0.24rem;
            overflow: auto;
            font-size: 0.15rem !important;
            word-break: normal;
            word-wrap: break-word;
            text-align: justify;
        }
        /deep/ p + h2 {
            padding-top: 0.12rem;
        }
        /deep/ p + h1 {
            padding-top: 0.12rem;
        }
        /deep/ ul + h2 {
            padding-top: 0.12rem;
        }
        /deep/ ol + h1 {
            padding-top: 0.12rem;
        }
        /deep/ p:has(video) {
            overflow: hidden;
        }
        /deep/ ul,
        /deep/ ol {
            margin: 0;
            padding: 0 0 0 0.12rem;
            p {
                .p-style();
            }
            li {
                line-height: 0.24rem;
                &:not(:last-child) {
                    margin-bottom: 0.04rem;
                }
            }
        }
        /deep/ ul {
            li {
                position: relative;
            }
            > li {
                list-style: none;
                &::before {
                    content: ' ';
                    display: inline-block;
                    font-size: 22px;
                    width: 0.05rem;
                    height: 0.05rem;
                    border-radius: 50%;
                    background-color: #000;

                    position: absolute;
                    top: 0.08rem;
                    left: -0.11rem;
                }
            }
        }
        /deep/ ol {
            li {
                list-style-position: inside !important;
                p:first-child {
                    display: inline;
                }
            }
        }
        /deep/ .reason-area:not(:first-child) {
            margin-top: 0.24rem;
        }
        /deep/ .reason-area-ol > li {
            line-height: 0.21rem;
            &:not(:last-child) {
                margin-bottom: 0.08rem;
            }
        }
        /deep/.ks-voc-editor-table {
            min-width: 100%;
            font-size: 16px;
            text-align: center;
            margin: 0 auto;
            border-collapse: separate;
            border-spacing: 0;
            border: 2px #000;
            margin-bottom: 0.16rem;

            table-layout: fixed;
            width: 100%;
            margin: 0;
            overflow: hidden;
            margin-bottom: 0.16rem;
            p {
                margin: 0;
                padding-bottom: 0;
                word-break: break-word;
                line-height: 0.2rem;
                overflow: unset;
                text-align: left;
            }
            .ks-voc-editor-table-header {
                text-align: left;
                background-color: #fff2f5;
                font-weight: bold;
            }

            thead tr,
            tbody tr {
                text-align: left;
                font-size: 0.14rem;
                height: 0.4rem;
            }
            tr th:first-child,
            tr td:first-child {
                border-left: 1px solid #eaeaea;
            }
            tr th:last-child,
            tr td:last-child {
                border-right: 1px solid #eaeaea;
            }
            tr td {
                border-bottom: 1px solid #eaeaea;
                vertical-align: top;
            }
            tr th {
                border-top: 1px solid #eaeaea;
                padding: 0.1rem 0.15rem;
            }
            tr td {
                padding: 0.12rem 0.15rem;
            }
            tr:first-child th:first-child {
                border-top-left-radius: 0.06rem;
            }

            tr:first-child th:last-child {
                border-top-right-radius: 0.06rem;
            }
            tr:last-child td:first-child {
                border-bottom-left-radius: 0.06rem;
            }

            tr:last-child td:last-child {
                border-bottom-right-radius: 0.06rem;
            }
        }
        /deep/.link-group {
            overflow: visible !important;
            height: auto;
            display: flex;
            justify-content: space-around;
            margin: 0.24rem 0;
            a {
                overflow: hidden;
                font-weight: 600;
            }
        }
        /deep/ div[data-child-count='2'] {
            a {
                .new-css-image ();
                width: 1.8rem;
                &:active {
                    opacity: 0.4;
                }
            }
            a:first-child {
                height: 0.46rem;
                border: 1px solid #fe3666;
                color: #fe3666;
            }
            a:last-child {
                background-color: #fe3666;
                color: white;
            }
        }
        /deep/ div[data-child-count='1'] {
            a {
                width: 2.56rem !important;
                background-color: #fe3666;
                color: white;
                .new-css-image();
                margin: auto;
                &:active {
                    opacity: 0.4;
                }
            }
        }
        /deep/ div[data-child-count='3'] {
            a {
                display: none;
                &:active {
                    opacity: 0.4;
                }
            }
            a:first-child,
            a:nth-child(2) {
                height: 0.38rem;
                border: 1px solid #fe3666;
                color: #fe3666 !important;
                width: 1.16rem;
                color: white;
                height: 0.38rem !important;
                line-height: 0.38rem !important;
                .new-css-image();
                font-weight: 400;
            }
            a:nth-child(3) {
                width: 1.22rem;
                background-color: #fe3666;
                width: 1.18rem;
                color: white;
                height: 0.4rem !important;
                line-height: 0.4rem !important;
                .new-css-image();
            }
        }
        /deep/ video {
            max-width: 99%;
            object-fit: cover;
            border-radius: 0.08rem;
            border: 0.1px solid #e0e0e0;
            overflow: hidden;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            &::-webkit-media-controls-fullscreen-button {
                display: none;
            }
        }
        /deep/.last-node {
            margin-bottom: 0 !important;
            padding-bottom: 0 !important;
        }
    }

    &--btn {
        margin: 24px 79px;
    }

    .new-css-image {
        height: 0.48rem;
        display: block;
        border-radius: 0.24rem;
        font-size: 0.15rem;
        text-align: center;
        line-height: 0.48rem;
    }
    .p-style {
        font-size: 0.15rem !important;
        margin: 0;
        padding-bottom: 0;
    }
}
</style>